<template>
	<dms-list-layout v-bind="layoutProps">
		<dms-table slot="content" v-bind="tableModel" v-on="tableListeners" />
	</dms-list-layout>
</template>

<script>
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store);
</script>
